// components/misc/RootNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const RootNode = ({ data, isConnectable }) => {
  return (
    <div className="p-4 bg-[#AABD7B] text-gray-900 text-bold text-2xl rounded-md nodrag">
      <Handle
        type="source"
        position={Position.Bottom} // Handle on the bottom
        id="b"
        isConnectable={isConnectable}
        className="w-2 h-2"
      />
      <Handle
        type="target"
        position={Position.Bottom} // Handle on the bottom
        id="b"
        isConnectable={isConnectable}
        className="w-2 h-2"
      />
      <div>{data.label}</div>
    </div>
  );
};

export default RootNode;
